<template>
  <ButtonGrid
    :audioContext="audioContext"
    :gridSize="gridSizes[gridSizesIndex]"
    :level="level"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ButtonGrid from "./components/ButtonGrid.vue";

export default defineComponent({
  name: "App",
  components: {
    ButtonGrid,
  },
  data() {
    return {
      audioContext: new AudioContext(),
      level: 1,
      gridSizesIndex: 0,
      gridSizes: [1, 4, 9, 16, 25, 36, 49, 64, 81],
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        this.levelUp();
      }
      if (e.key === "ArrowUp") {
        this.levelDown();
      }
    });
  },
  methods: {
    levelUp() {
      if (this.level < this.gridSizes.length) {
        this.level++;
        this.gridSizesIndex++;
      }
    },
    levelDown() {
      console.log(this.level);
      if (this.level > 1) {
        this.level--;
        this.gridSizesIndex--;
      }
    },
  },
});
</script>

<style>
body {
  background-color: #141124;
}

p,
a {
  color: white;
  font-size: 18px;
  margin: 0.5em;
}
</style>
